import type { Project } from "../types";
import { asset } from "../lib/asset";
import { useI18n } from "../i18n/LanguageContext";
import { Icon } from "./Icon";
import styles from "./ProjectDetails.module.css";

export function ProjectDetails({ project }: { project: Project }) {
  const { t, ui } = useI18n();

  const categoryLabel =
    project.category === "commercial"
      ? ui.portfolio.badges.commercial
      : ui.portfolio.badges.openSource;

  return (
    <div className={styles.wrap}>
      <div className={styles.meta}>
        <span className={styles.metaAccent}>{t(project.platform)}</span>
        <span className="chip">{project.year}</span>
        <span className="chip">{categoryLabel}</span>
      </div>

      {t(project.description).map((paragraph, i) => (
        <p key={i} className={styles.paragraph}>
          {paragraph}
        </p>
      ))}

      {project.features && (
        <ul className={styles.features}>
          {t(project.features).map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
      )}

      {project.gallery && (
        <div className={styles.gallery}>
          {project.gallery.map((src, i) => (
            <a
              key={src}
              href={asset(src)}
              target="_blank"
              rel="noreferrer"
              className={styles.shot}
            >
              <img
                src={asset(src)}
                alt={ui.a11y.screenshot
                  .replace("{title}", project.title)
                  .replace("{n}", String(i + 1))}
                loading="lazy"
              />
            </a>
          ))}
        </div>
      )}

      <div className={styles.tags}>
        {project.tags.map((tag) => (
          <span key={tag} className="chip">
            {tag}
          </span>
        ))}
      </div>

      {project.links.length > 0 && (
        <div className={styles.links}>
          {project.links.map((link) => (
            <a
              key={link.url}
              href={link.url}
              target="_blank"
              rel="noreferrer"
              className="btn btn--primary"
            >
              <Icon name="github" size={16} />
              {link.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
